module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-4-e4f2bce19f1e935077fb2cecfc6731b8.webp";